// @ts-check
import { useHistory } from "react-router-dom";
import { useIncidentTemplateDataGridContext } from '~/components/Incidents/IncidentTemplateDataGrid/IncidentTemplateDataGrid.context';
import { EventNames } from '~/components/Incidents/IncidentTemplateDataGrid/IncidentTemplateDataGrid.utils';
import useOrganizationId from '~/hooks/useOrganizationId';
import FormOptionsModal from '~/components/AdminPages/ManageForms/FormOptionsModal';
import { useZeroContext } from '~/components/ZeroContext';
import { FormType } from '~/other/Constants';

export function IncidentTemplateDataGridModals({ showCreateModal, onCloseCreateModal }) {
    const history = useHistory();
    const { events } = useZeroContext();
    const { activeModal, setActiveModal } = useIncidentTemplateDataGridContext();
    const orgId = useOrganizationId();

    if (showCreateModal) {
        return (
            <FormOptionsModal
                show
                cancel={onCloseCreateModal}
                complete={onCloseCreateModal}
                form_to_edit={null}
                team_access={false}
                forceFormType={FormType.INCIDENT}
                refresh={() => events.emit(EventNames.REFRESH_DATA)}
            />
        );
    }

    if (!activeModal) {
        return null;
    }

    const { key, form } = activeModal;
    const closeModal = () => setActiveModal(null);
    const refreshDataGrid = () => events.emit(EventNames.REFRESH_DATA);

    switch (key) {
        case "edit_template":
            return (
                <FormOptionsModal
                    show
                    cancel={closeModal}
                    complete={closeModal}
                    form_to_edit={form}
                    team_access={false}
                    forceFormType={FormType.INCIDENT}
                    refresh={refreshDataGrid}
                />
            );

        default:
            console.error(`Unknown incident template table modal '${key}'`);
    }

    return null;
} 